import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcExpandedRowDetail]'
})
export class ExpandedRowDetailDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
